<template lang="pug">
  .b2b-page-pendings-task
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='4')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='20')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("pendingtask.buttons.btnCreate")', placement='bottom')
                ods-button(
                  v-if='canCreateCover && (pendingTaskDetailForm.pendingTask==null || pendingTaskDetailForm.pendingTask)',
                  icon='ods-icon-plus',
                  type='primary',
                  size='small',
                  circle,
                  @click.native='goCreateCover')
                  | {{ $t('pendingtask.buttons.btnCreate') }}
              ods-tooltip(:content="buttonLabel", placement='bottom')
                ods-button(
                  v-if="canShowApprovalButton()",
                  :icon="buttonIcon",
                  type='primary',
                  size='small',
                  circle,
                  @click.native='isShowDialogApproveInvoice = true')
                  | {{ buttonLabel }}
              ods-tooltip(:content='$t("pendingtask.buttons.btnRejected")', placement='bottom')
                ods-button(
                  v-if="canShowRejectButton()",
                  icon='ods-icon-disable',
                  type='primary',
                  circle,
                  size='small',
                  @click.native='isShowDialogRejectedInvoice = true')
                  | {{ $t('pendingtask.buttons.btnRejected') }}
              ods-tooltip(:content='$t("pendingtask.buttons.btnPaymentProposal_tooltip")', placement='bottom')
                ods-button(
                  v-if='canCreateCover && (pendingTaskDetailForm.pendingTask==null || pendingTaskDetailForm.pendingTask)',
                  type='primary',
                  icon='ods-icon-refund',
                  circle,
                  size='small',
                  @click.native='showSendPaymentProposal')
                  | {{ $t('pendingtask.buttons.btnPaymentProposal') }}
              ods-tooltip(:content='$t("pendingtask.buttons.btnSendInvoice_tooltip")', placement='bottom')
                ods-button(
                  v-if='(pendingTaskDetailForm.pendingTask==null || pendingTaskDetailForm.pendingTask) && pendingTaskDetailForm.sent==null && sendManual',
                  icon='ods-icon-upload',
                  circle,
                  type='primary',
                  size='small',
                  @click.native='sendToSapInvoice')
                  | {{ $t('pendingtask.buttons.btnSendInvoice') }}
              ods-tooltip(:content='$t("pendingtask.buttons.btnDownloadPdf_tooltip")', placement='bottom')
                ods-button(
                  type='primary',
                  icon='ods-icon-download',
                  circle,
                  size='small',
                  @click.native='downloadPdf')
                  | {{ $t('pendingtask.buttons.btnDownloadPdf') }}
              ods-tooltip(:content='$t("pendingtask.buttons.btnDownloadOriginal_tooltip")', placement='bottom')
                ods-button(
                  type='primary',
                  icon='ods-icon-download',
                  circle,
                  size='small',
                  @click.native='downloadSignedOriginal')
                  | {{ $t('pendingtask.buttons.btnDownloadOriginal') }}
              ods-tooltip(:content='$t("pendingtask.buttons.btnDownloadMetadata_tooltip")', placement='bottom')
                ods-button(
                  v-if="(canAdminIndra || canViewMetadataPendingTask) && canDownloadMetadata"
                  type='primary',
                  icon='ods-icon-download',
                  circle,
                  size='small',
                  @click.native='handleDownloadMetadata')
                  | {{ $t('pendingtask.buttons.btnDownloadMetadata') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.redigitize_invoice_tooltip")', placement='bottom')
                ods-button(
                  v-if='canRedigitize',
                  type='primary',
                  icon='ods-icon-print',
                  size='small',
                  circle,
                  @click.native='handleRedigitalize')
                  | {{ $t('invoice_detail.buttons.redigitize_invoice') }}

      ods-form(
        ref='pendingTaskDetailForm',
        :model='pendingTaskDetailForm',
        :rules='rulesPendingTask',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.seller")',
              prop='sellerName')
              ods-input(
                v-model='pendingTaskDetailForm.sellerName',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.num_pendingtask")',
              prop='invoiceNumber')
              ods-input(
                v-model='pendingTaskDetailForm.invoiceNumber',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.import")',
              prop='totalExecutableAmount')
              ods-input(
                v-model='pendingTaskDetailForm.totalExecutableAmount',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.status")',
              prop='status')
              ods-input(
                v-model='pendingTaskDetailForm.status',
                :disabled='true')
            ods-form-item(
              v-if='canChangeStatusPendingTask'
              :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
              prop='observations')
              ods-input(
                v-model='pendingTaskDetailForm.observations')
            ods-form-item(
              v-if='newStatus && canChangeStatusPendingTask',
              :label='$t("pendingtask.pendingtask_detail.rejectedinvoice.category")',
              prop='category')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='pendingTaskDetailForm.category',
                filterable,
                :placeholder='$t("pendingtask.pendingtask_detail.rejectedinvoice.category")' )
                ods-option(
                  v-for='option in categories',
                  :key='option.id',
                  :label='option.code',
                  :value='option.id')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.reception_method")',
              prop='receptionMethod')
              ods-input(
                v-model='pendingTaskDetailForm.receptionMethod',
                :disabled='true')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.buyer")',
              prop='buyerName')
              ods-input(
                v-model='pendingTaskDetailForm.buyerName',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.issue_date")',
              prop='issueDate')
              ods-input(
                v-model='issueDateFormatted',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.divisa")',
              prop='currencyCode')
              ods-input(
                v-model='pendingTaskDetailForm.currencyCode',
                :disabled='true')
            ods-form-item(
              v-if='canChangeStatusPendingTask'
              :label='$t("invoice_detail.invoice_detail_edit_form.change_state.label")',
              prop='statusId')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='pendingTaskDetailForm.statusId',
                filterable,
                :placeholder='$t("invoice_detail.invoice_detail_edit_form.change_state.placeholder")'
                 @change='changeStatus')
                ods-option(
                  v-for='option in statushermes',
                  :key='option.id',
                  :label='$t("invoice_status."+option.code)',
                  :value='option.id')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.internal_status")',
              prop='internalStatus')
              ods-input(
                v-model='pendingTaskDetailForm.internalStatus',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.creation_date")',
              prop='creationDateTime')
              ods-input(
                v-model='creationDateTimeFormatted',
                :disabled='true')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.pendingtask")',
              prop='pendingTask')
              ods-switch(
                v-model='pendingTaskDetailForm.pendingTask',
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                :disabled='true')
        ods-row(type='flex')
          ods-col(:span='24')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_entity_table.internal_notes")',
              prop='internalNotes')
              ods-input(
                type='textarea',
                :rows='5',
                v-model='pendingTaskDetailForm.internalNotes')
    ods-row.form-actions()
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            @click='submitInvoiceDetailEditForm("pendingTaskDetailForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnCancel_tooltip")', placement='bottom')
          ods-button(
            ref='buttonCancel',
            type='neutral',
            size='large'
            @click='cancelInvoiceDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse
      ods-accordion(@change="loadAttachments")
        ods-accordion-item(
          v-if='canSeeAttachments',
          name='1')
          template(slot='title')
            span  {{ $t('pendingtask.pendingtask_detail.attachments_table.attachments') }}
            span.info(v-show='!attachments.length && attachmentMessage') {{ $t('pendingtask.pendingtask_detail.attachments_table.no_date') }}
          ods-tooltip(:content='$t("pendingtask.pendingtask_detail.attachments_table.load_tooltip")', placement='bottom')
            ods-button.button-collapse(
              v-if='canAddAttachments',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogAddInvoiceAttachment = true')
              | {{ $t('pendingtask.pendingtask_detail.attachments_table.load') }}

          //- Tabla de Adjuntos
          ods-table(
            v-if='attachments.length > 0 ',
            :data='attachments',
            :default-sort="{ prop: 'creationDate', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterAttchments',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='filename',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.fiename")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.category")',
              :show-overflow-tooltip='true',
              :formatter='formatterCategoryAndAction',
              sortable='')
            ods-table-column(
              prop='size',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.size")',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='compressedSize',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.compressedSize")',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='hidden',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.hidden")',
              :show-overflow-tooltip='true',
              :formatter='formatterBoolean',
              sortable='')
            ods-table-column(
              prop='creationDate',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.creationDate")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='author',
              :label='$t("pendingtask.pendingtask_detail.attachments_table.author")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              width='80')
              template(slot-scope='scope')
                ods-button.first-button(
                  type='neutral',
                  @click='downloadAttachment')
                  ods-icon(name='download', size='16')
                ods-button(
                  v-if='canDeleteAttachments && (scope.row.erasable == null || scope.row.erasable)'
                  type='neutral',
                  @click='removeAttachment')
                  ods-icon(name='close', size='16')
      ods-accordion(@change="loadEvents")
        ods-accordion-item(
          v-if='canSeeEventsBpm',
          name='2')
          template(slot='title')
            span {{ $t('invoice_detail.eventsbpm.title') }}
            span.info(v-show='!events.length && eventMessage') {{ $t('invoice_detail.events.no_events') }}
          //- Tabla eventos
          ods-table(
            v-if='events.length > 0 ',
            :data='events',
            :default-sort="{prop: 'id', order: 'ascending'}",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='action',
              :label='$t("pendingtask.pendingtask_detail.event_table.action")',
              :show-overflow-tooltip='true',
              :formatter='formatterCategoryAndAction',
              sortable='')
            ods-table-column(
              prop='eventCreationDate',
              :label='$t("pendingtask.pendingtask_detail.event_table.date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("pendingtask.pendingtask_detail.event_table.category")',
              :show-overflow-tooltip='true',
              :formatter='formatterCategoryAndAction',
              sortable='')
            ods-table-column(
              prop='userOrigin',
              :label='$t("pendingtask.pendingtask_detail.event_table.user_origin")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='userDestination',
              :label='$t("pendingtask.pendingtask_detail.event_table.user_destiny")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='description',
              :label='$t("pendingtask.pendingtask_detail.event_table.observations")',
              :show-overflow-tooltip='true',
              sortable='')

    //- Dialog Cargar Doc Adjunto
    ods-dialog(
      ref='dialogAddInvoiceAttachment',
      title='Carga un documento adjunto',
      :visible.sync='isShowDialogAddInvoiceAttachment',
      @close='handleCloseDialogAddInvoiceAttachment',
      width='30%')
      ods-form(
        ref='formDialogAddInvoiceAttachment',
        :rules='rulesDialogAddInvoiceAttachment',
        :model='formDialogAddInvoiceAttachment')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            v-model='formDialogAddInvoiceAttachment.fichero',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormatsAccept.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('invoice_detail.dialog_add_invoice_attachment.file_selected') }}
        ods-form-item(v-if='canAttachmentHidden')
          ods-checkbox(v-model='formDialogAddInvoiceAttachment.checkAddAttachment')
            span {{ $t('msg_generics.upload_attachment_interlocutor') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddInvoiceAttachment("formDialogAddInvoiceAttachment")')
          | {{ $t('invoice_detail.dialog_add_invoice_attachment.load_document') }}

    //- Dialogo Propuesta de pago
    ods-dialog(
      ref='dialogPaymentProposal',
      :title='$t("pendingtask.pendingtask_detail.paymentproposal.title")',
      :visible.sync='isShowDialogPaymentProposal',
      width='30%')
      ods-form(
        ref='formDialogPaymentProposalForm',
        :model='dialogPaymentProposalForm')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.paymentproposal.name")',
          size='mini',
          prop='namePaymentProposal')
          ods-input(
            :disabled='true',
            v-model='dialogPaymentProposalForm.namePaymentProposal')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.paymentproposal.invoicenumber")',
          size='mini',
          prop='invoiceNumber')
          ods-input(
            :disabled='true',
            v-model='dialogPaymentProposalForm.invoiceNumber')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.paymentproposal.status")',
          size='mini',
          prop='status')
          ods-input(
            :disabled='true',
            v-model='dialogPaymentProposalForm.status')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.paymentproposal.description")',
          size='mini',
          prop='description')
          ods-input(
            :disabled='true',
            v-model='dialogPaymentProposalForm.description')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='sendToPaymentProposalInvoice')
          | {{ $t('pendingtask.pendingtask_detail.paymentproposal.btnsend') }}

    //- Dialogo Rechazo de factura
    ods-dialog(
      ref='dialogRejectedInvoice',
      :title='$t("pendingtask.pendingtask_detail.rejectedinvoice.title")',
      :visible.sync='isShowDialogRejectedInvoice',
      @close='handleCloseDialog',
      width='30%')
      ods-form(
        ref='formDialogRejectedInvoiceForm',
        :model='dialogRejectedInvoiceForm',
        :rules='rulesDialogRejectedInvoice')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.rejectedinvoice.status")',
          size='mini',
          prop='status')
          ods-input(
            :disabled='true',
            v-model='dialogRejectedInvoiceForm.status')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.rejectedinvoice.statusnext")',
          size='mini',
          prop='statusnext')
          ods-input(
            :disabled='true',
            v-model='dialogRejectedInvoiceForm.statusnext')
        ods-form-item(
          prop='categoryId'
          :label='$t("pendingtask.pendingtask_detail.rejectedinvoice.category")',
          size='mini')
          ods-select(
            no-match-text='$t("msg_generics.no_match")',
            v-model='dialogRejectedInvoiceForm.categoryId',
            filterable,
            :placeholder='$t("pendingtask.pendingtask_detail.rejectedinvoice.category")' )
            ods-option(
              v-for='option in categories',
              :key='option.id',
              :label='option.code',
              :value='option.id')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.rejectedinvoice.motive")',
          size='mini',
          prop='motive')
          ods-input(
            type='textarea',
            :placeholder='$t("pendingtask.pendingtask_detail.rejectedinvoice.motive")',
            v-model='dialogRejectedInvoiceForm.motive')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitRejectedInvoiceNote("formDialogRejectedInvoiceForm")')
          | {{ $t('buttons.btnOk') }}
    //- Dialogo aprobación/envío de factura para el flujo de aprobación por niveles
    ods-dialog(
      ref='dialogApproveInvoice',
      :title='getTitleForApprovalDialog()',
      :visible.sync='isShowDialogApproveInvoice',
      @close='handleCloseDialogApprove',
      width='54%')
      ods-form(
        ref='formDialogApproveInvoiceForm',
        :model='dialogApproveInvoiceForm',
        :rules='rulesDialogApproveInvoice')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.approveinvoice.status")',
          size='mini',
          prop='levelApproval')
          ods-input(
            :disabled='true',
            v-model='dialogApproveInvoiceForm.levelApproval')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.approveinvoice.statusnext")',
          v-if='!pendingTaskDetailForm.isLastLevelInApprovalFlow',
          size='mini',
          prop='nextLevel')
          ods-input(
            :disabled='true',
            v-model='dialogApproveInvoiceForm.nextLevel')
        ods-row(type='flex', justify='space-between', v-if='fields.length > 0 && dialogApproveInvoiceForm.levelApproval === 1')
          ods-col(v-for='field in fields' :key='field' :span='Math.floor(20 / fields.length)')
            ods-form-item(:label='field', size='mini')
              ods-input(v-model='dialogApproveInvoiceForm[field]', :placeholder='field')
          ods-col(:span='2')
            ods-button(
              v-if='projectWithOptionalFieldsApprovalFlowConfiguration && dialogApproveInvoiceForm.levelApproval === 1',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='addApprovalField')
              | {{ $t('buttons.btnAdd') }}
        ods-table(
          v-if='linesApprovalParameters.length > 0 && projectWithOptionalFieldsApprovalFlowConfiguration',
          :data='linesApprovalParameters',
          style='width: 100%',
          @cell-mouse-enter='handleCellMouseEnter',
          highlight-current-row,
          size='mini',
          fit)
          ods-table-column(
            v-for='column in fields',
            :key='column',
            :prop='column',
            :label='column',
            :show-overflow-tooltip='true',
            sortable='')
          ods-table-column(
            label=''
            width='60')
            template(slot-scope='scope')
              ods-button(
                v-if='projectWithOptionalFieldsApprovalFlowConfiguration && dialogApproveInvoiceForm.levelApproval === 1',
                type='neutral',
                @click='removeApprovalParameters')
                ods-icon(name='close', size='16')
        ods-form-item.customMargin(
          prop='categoryId'
          :label='$t("pendingtask.pendingtask_detail.approveinvoice.category")',
          size='mini')
          ods-select(
            no-match-text='$t("msg_generics.no_match")',
            v-model='dialogApproveInvoiceForm.categoryId',
            filterable,
            :placeholder='$t("pendingtask.pendingtask_detail.approveinvoice.category")' )
            ods-option(
              v-for='option in categories',
              :key='option.id',
              :label='option.code',
              :value='option.id')
        ods-form-item(
          :label='$t("pendingtask.pendingtask_detail.approveinvoice.motive")',
          size='mini',
          prop='motive')
          ods-input(
            type='textarea',
            :placeholder='$t("pendingtask.pendingtask_detail.approveinvoice.motive")',
            v-model='dialogApproveInvoiceForm.motive')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitApproveInvoiceNote("formDialogApproveInvoiceForm")')
          | {{ $t('buttons.btnOk') }}
    //- Dialog Redigitalizar factura
    ods-dialog(
      :title='$t("invoice_detail.dialog_redigitize.title")',
      ref='dialogRedigitalizer',
      :visible.sync='isShowDialogRegitize',
      @close='handleCloseDialogRedigitalize',
      width='30%')
      ods-form(
        ref='formDialogRedigitize',
        :model='formDialogRedigitize',
        :rules='rulesFormDialogRedigitize')
        ods-form-item(
          :label='$t("invoice_detail.dialog_redigitize.checkboxes.label")',
          prop='category')
          br
          br
          div
            ods-radio(
              v-model='formDialogRedigitize.category'
              :label='redigitizeFields.badCaptured.label') {{ redigitizeFields.badCaptured.message }}
          div
            ods-radio.separate(
              v-model='formDialogRedigitize.category'
              :label='redigitizeFields.noCaptured.label') {{ redigitizeFields.noCaptured.message }}
          div
            ods-radio.separate(
              v-model='formDialogRedigitize.category'
              :label='redigitizeFields.incorrect.label') {{ redigitizeFields.incorrect.message }}
          div
            ods-radio.separate(
              v-model='formDialogRedigitize.category'
              :label='redigitizeFields.others.label') {{ redigitizeFields.others.message }}
        br
        ods-form-item(
          :label='$t("invoice_detail.dialog_redigitize.commentary")',
          prop='comentarioSolicitud')
          ods-input(
            type="textarea",
            :rows="2",
            v-model="formDialogRedigitize.comentarioSolicitud")
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitRedigitalizerInvoice("formDialogRedigitize")')
          | {{ $t('buttons.btnConfirm') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import router from '@/router/index'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-pendings-task',
  mixins: [Utils],
  data () {
    return {
      newStatus: false,
      notaInterna: null,
      invoiceOriginal: {}, // Factura original sin modificaciones de ningun tipo
      invoiceId: null,
      searchType: 'RECEIVED',
      events: [], // listado eventos
      categories: [], // combo categorias
      statushermes: [], // combo estados hermes
      project: {}, // proyecto de la factura
      projectId: null,
      pendingTaskDetailForm: {
        internalNotes: '',
        size: null,
        compressedSize: null,
        projectName: null,
        observations: '',
        statusId: null,
        category: null
      },
      currentRow: {}, // Eventos

      fields: [], // campos requeridos para la aprobación
      projectWithOptionalFieldsApprovalFlowConfiguration: false, // true si el proyecto tiene la conFiguracion de campos adicionales para la aprobación, false en caso contrario
      approvalParameters: [], // parametros de aprobación
      linesApprovalParameters: [], // lineas de parametros de aprobación
      numMaxLine: null,

      // Propuesta de pago
      isShowDialogPaymentProposal: false,
      dialogPaymentProposalForm: {
        motive: null
      },
      projectWithApprovalFlowConfiguration: false, // true si el proyecto tiene la configuración de flujo de aprobación, false en caso contrario
      // Adjuntos
      attachments: [],
      currentRowAttachments: {},
      fileList: [],
      isShowDialogAddInvoiceAttachment: false,
      formDialogAddInvoiceAttachment: {
        fichero: null,
        checkAddAttachment: null
      },
      extensionFormatsAccept: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg'],
      extensionFormats: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg'],

      sendManual: false,
      eventFlag: true,
      eventMessage: false,
      attachmentFlag: true,
      attachmentMessage: false,
      // REDIGITALIZAR
      formDialogRedigitize: {
        category: null,
        comentarioSolicitud: null
      },
      rulesFormDialogRedigitize: {
        comentarioSolicitud: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        category: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ]
      },
      redigitizeFields: {
        badCaptured: {
          message: this.$t('invoice_detail.dialog_redigitize.checkboxes.field_bad_captured'),
          label: 'WRONG_CAPTURED'
        },
        noCaptured: {
          message: this.$t('invoice_detail.dialog_redigitize.checkboxes.field_no_captured'),
          label: 'NO_CAPTURED'
        },
        incorrect: {
          message: this.$t('invoice_detail.dialog_redigitize.checkboxes.field_incorrect'),
          label: 'WRONG_FIELD_CAPTURED'
        },
        others: {
          message: this.$t('invoice_detail.dialog_redigitize.checkboxes.field_others'),
          label: 'OTHERS'
        }
      },
      // Aprobación/envío de factura para el flujo de aprobación por niveles
      isShowDialogApproveInvoice: false,
      // Rechazo de factura
      isShowDialogRejectedInvoice: false,
      dialogRejectedInvoiceForm: {
        status: null,
        statusnext: this.$t('pendingtask.pendingtask_detail.rejectedinvoice.statusrejected')
      },
      dialogApproveInvoiceForm: {
        levelApproval: null,
        nextLevel: null,
        categoryId: null,
        motive: null,
        field: null,
        value: null
      },
      // Redigitalizar
      canRedigitize: false,
      isShowDialogRegitize: false,
      canDownloadMetadata: false,
      rulesDialogRejectedInvoice: {
        categoryId: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.rejectedinvoice.categoryselected'
            ),
            trigger: 'change'
          }
        ],
        motive: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.rejectedinvoice.motive_required'
            ),
            trigger: 'change'
          },
          {
            max: 1000,
            message: this.$t('validations.maxlenght', { maxlenght: 1000 }),
            trigger: 'change'
          }
        ]
      },
      rulesDialogApproveInvoice: {
        categoryId: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.rejectedinvoice.categoryselected'
            ),
            trigger: 'change'
          }
        ],
        motive: [
          {
            max: 1000,
            message: this.$t('validations.maxlenght', { maxlenght: 1000 }),
            trigger: 'change'
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Combos
      'optionsFilterCategoriesPendingTask',
      // Permisos
      'canSeeAttachments',
      'canAddAttachments',
      'canDeleteAttachments',
      'canCreateCover',
      'canUserApprovalFlowByLevels', // permite aprobar, rechazar y enviar facturas en el flujo de aprobación por niveles
      'canAttachmentHidden',
      'canChangeStatusPendingTask',
      'primaryColor',
      'canAdminIndra',
      'canViewMetadataPendingTask',
      'canSeeEventsBpm',
      'urlIn'
    ]),
    rulesDialogAddInvoiceAttachment () {
      const checkExtension = (rule, value, callback) => {
        // Obtener la extension, y cuando la tengas, haces la validacion
        if (!this.validateExtension(this.formDialogAddInvoiceAttachment.fichero.name)) {
          this.formDialogAddInvoiceAttachment.fichero = null
          callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '.' + this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension_values') + this.extensionFormats.toString()))
        } else {
          this.fileList = []
          this.fileList.push(this.formDialogAddInvoiceAttachment.fichero)
          callback()
        }
      }
      return {
        fichero: [
          { required: true, message: this.$t('pendingtask.pendingtask_detail.attachments_table.fileselected'), trigger: 'click' },
          { validator: checkExtension }
        ]
      }
    },
    issueDateFormatted () { // eslint-disable-line
      if (this.pendingTaskDetailForm.issueDate) {
        const date = new Date(this.pendingTaskDetailForm.issueDate)
        return this.$d(date)
      }
    },

    creationDateTimeFormatted () { // eslint-disable-line
      if (this.pendingTaskDetailForm.creationDateTime) {
        const date = new Date(this.pendingTaskDetailForm.creationDateTime)
        return this.$d(date, 'long')
      }
    },

    rulesPendingTask () {
      const checkObservations = (rule, value, callback) => {
        const self = this
        const estado = this.statushermes.find(function (t) {
          return t.id === self.pendingTaskDetailForm.statusId
        })
        const observations = this.pendingTaskDetailForm.observations
        if (estado && (estado.code === 'REJECTED' || estado.code === 'CANCELLED' ||
               estado.code === 'ERROR' || estado.code === 'ANNULLED') && !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      const checkCategories = (rule, value, callback) => {
        const status = this.pendingTaskDetailForm.statusId
        const category = this.pendingTaskDetailForm.category
        if (status && !category) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      return {
        observations: [
          { max: 255, message: this.$t('msg_generics.max_num_character', { max: 255 }), trigger: 'blur, change' },
          { validator: checkObservations, trigger: 'blur, change' }
        ],
        category: [
          { validator: checkCategories, trigger: 'blur, change' }
        ],
        internalNotes: [
          { max: 255, message: this.$t('msg_generics.max_num_character', { max: 255 }), trigger: 'blur, change' }
        ]
      }
    },

    buttonLabel () {
      return this.pendingTaskDetailForm.levelApproval != null && this.pendingTaskDetailForm.isLastLevelInApprovalFlow
        ? this.$t('pendingtask.buttons.btnSend')
        : this.$t('pendingtask.buttons.btnApprove')
    },
    buttonIcon () {
      return this.pendingTaskDetailForm.levelApproval != null && this.pendingTaskDetailForm.isLastLevelInApprovalFlow
        ? 'ods-icon-upload'
        : 'ods-icon-tick-large'
    },
    approvalDialogSuccess () {
      return this.pendingTaskDetailForm.levelApproval != null && this.pendingTaskDetailForm.isLastLevelInApprovalFlow
        ? this.$t('pendingtask.pendingtask_detail.approveinvoice.send_ok')
        : this.$t('pendingtask.pendingtask_detail.approveinvoice.approved_ok')
    },
    loadingInApprovalDialog () {
      return this.pendingTaskDetailForm.levelApproval != null && this.pendingTaskDetailForm.isLastLevelInApprovalFlow
        ? this.$t('pendingtask.pendingtask_detail.approveinvoice.send')
        : this.$t('pendingtask.pendingtask_detail.approveinvoice.approved')
    }

  },

  methods: {
    ...mapActions([
      'getPendingTaskById',
      'downloadPendingTaskPdf',
      'getEvents',
      'downloadInvoiceSignedOriginalPendingTask',
      'downloadMetadata',
      'getInvoiceNoteAttachmentsPendingTask',
      'downloadInvoiceNoteAttachmentPendingTask',
      'removeInvoiceNoteAttachmentPendingTask',
      'addInvoiceNoteAttachmentPendingTask',
      'getInvoiceNoteInternalPendingTask',
      'modifyInvoiceNoteInternalNotesPendingTask',
      'sendToSap',
      'getPaymentProposal',
      'sendPaymentProposal',
      'rejectedInvoice',
      'getOptionsCategories',
      'getProjectByName',
      'getStatusHermesPendingTask',
      'modifyStatusHermesPendingTask',
      'sendRedigitalization',
      'invoiceNoteIdsPendingTaskState',
      'getSendManualConfig',
      'getDataConfigurationCode',
      'getDataConfigurationValueByCode',
      'sendApproveInvoice',
      'addInvoiceNoteApprovalParameterPendingTask',
      'getInvoiceNoteApprovalParametersPendingTask',
      'removeInvoiceNoteApprovalParameterPendingTask'
    ]),

    canShowRejectButton () {
      return (
        this.canCreateCover &&
        (this.pendingTaskDetailForm.pendingTask == null || this.pendingTaskDetailForm.pendingTask) &&
        ((this.pendingTaskDetailForm.sent !== null && this.pendingTaskDetailForm.sent && this.invoiceOriginal.internalStatus === 'REJECTED') ||
          (this.pendingTaskDetailForm.sent !== null && !this.pendingTaskDetailForm.sent) ||
          this.pendingTaskDetailForm.sent == null
        )) ||
        (this.canUserApprovalFlowByLevels && this.projectWithApprovalFlowConfiguration &&
        (this.pendingTaskDetailForm.pendingTask == null || this.pendingTaskDetailForm.pendingTask) &&
        this.pendingTaskDetailForm.LevelApproval !== null && this.pendingTaskDetailForm.LevelApproval !== 0 &&
        this.invoiceOriginal.internalStatus !== 'SENDED' && this.invoiceOriginal.status !== 'REJECTED')
    },
    canShowApprovalButton () {
      return (
        this.canUserApprovalFlowByLevels && this.projectWithApprovalFlowConfiguration &&
        (this.pendingTaskDetailForm.pendingTask == null || this.pendingTaskDetailForm.pendingTask) &&
        this.pendingTaskDetailForm.levelApproval != null &&
        this.invoiceOriginal.internalStatus !== 'SENDED' && this.invoiceOriginal.status !== 'REJECTED')
    },

    changeStatus (data) {
      const estado = this.statushermes.find(function (t) {
        return t.id === data
      })
      this.newStatus = false
      if (this.categories.length > 0 && estado.code === 'REJECTED') {
        this.newStatus = true
      }
      this.$refs.pendingTaskDetailForm.clearValidate()
    },

    // Reseteo al cerrar dialogo
    handleCloseDialog () {
      this.$refs.formDialogRejectedInvoiceForm.resetFields()
    },
    // Reseteo al cerrar dialogo
    handleCloseDialogApprove () {
      this.$refs.formDialogApproveInvoiceForm.resetFields()
    },
    // Redigitalizar
    handleRedigitalize () {
      this.isShowDialogRegitize = true
    },
    handleCloseDialogRedigitalize () {
      this.$refs.formDialogRedigitize.resetFields()
      this.formDialogRedigitize.category = null
    },
    async goCreateCover () {
      router.push({
        name: 'create-cover',
        params: {
          invoiceNumber: this.dialogPaymentProposalForm.invoiceNumber,
          projectId: this.projectId,
          invoiceId: this.$route.params.invoiceId
        }
      })
    },

    getTitleForApprovalDialog () {
      if (this.pendingTaskDetailForm.levelApproval != null && this.pendingTaskDetailForm.isLastLevelInApprovalFlow) {
        return this.$t('pendingtask.pendingtask_detail.approveinvoice.title2')
      } else {
        return this.$t('pendingtask.pendingtask_detail.approveinvoice.title1')
      }
    },

    // Formatea un booleano en si no
    formatterBoolean (row) {
      if (row.hidden === true) {
        return this.$t('msg_generics.question.yes')
      } else {
        return this.$t('msg_generics.question.no')
      }
    },

    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    formatterCategoryAndAction (row, column) {
      return row[column.property] ? this.$t('auditory_detail.events.code.' + row[column.property]) : ' '
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    handleCellMouseEnterAttchments (row, column, cell, event) {
      this.currentRowAttachments = row
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddInvoiceAttachment.fichero = file
      this.$refs.formDialogAddInvoiceAttachment.validateField('fichero')
    },

    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    handleProgress (event, file, fileList) {
      console.log('handleProgress: ', event)
      console.log('handleProgress: ', file)
      console.log('handleProgress: ', fileList)
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo formulario al cerrar dialogo de añadir adjunto
    handleCloseDialogAddInvoiceAttachment () {
      this.$refs.formDialogAddInvoiceAttachment.resetFields()
      this.fileList = []
    },
    // Redigitalizar
    onSubmitRedigitalizerInvoice (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.redigitize')
          })
          try {
            await this.sendRedigitalization({
              idInvoice: this.invoiceId,
              category: this.formDialogRedigitize.category,
              comentarioSolicitud: this.formDialogRedigitize.comentarioSolicitud,
              searchType: this.searchType
            })
            this.$refs.formDialogRedigitize.resetFields()
            this.isShowDialogRegitize = false
            this.$notify({
              title: this.$t('msg_generics.redigitize_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await router.push({
              name: 'tareaspendientes-page'
            })
          } catch (error) {
            console.log('onSubmitAddInvoiceAttachment CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    // Subida de un adjunto
    onSubmitAddInvoiceAttachment (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid && this.invoiceId) {
          console.log('onSubmitAddInvoiceAttachment!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            await this.addInvoiceNoteAttachmentPendingTask({
              attachment: this.fileList[0],
              hidden: this.formDialogAddInvoiceAttachment.checkAddAttachment,
              invoiceNoteId: this.invoiceId
            })
            await this.getInvoiceNoteAttachmentsOnDatabase()

            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddInvoiceAttachment = false
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    // Descarga adjunto
    async downloadAttachment () {
      console.log('downloadAttachment: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t(
          'pendingtask.pendingtask_detail.attachments_table.download'
        )
      })

      try {
        const filename = await this.downloadInvoiceNoteAttachmentPendingTask({
          invoiceNoteId: this.invoiceId,
          attachmentId: this.currentRowAttachments.id
        })
        this.$notify({
          title: this.$t('pendingtask.pendingtask_detail.notify.download', {
            file: filename
          }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Eliminación de adjunto
    async removeAttachment () {
      this.$confirm(this.$t('draft_detail.confirm.title_delete_attachment'), {
        confirmButtonText: this.$t('draft_detail.confirm.confirm_button_delete_attachment'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        console.log('removeAttachment: ', this.invoiceId)
        const load = this.$loading({
          lock: true,
          text: this.$t('pendingtask.pendingtask_detail.attachments_table.delete')
        })
        try {
          await this.removeInvoiceNoteAttachmentPendingTask({
            invoiceNoteId: this.invoiceId,
            attachmentId: this.currentRowAttachments.id
          })
          await this.getInvoiceNoteAttachmentsOnDatabase()
          this.$notify({
            title: this.$t(
              'pendingtask.pendingtask_detail.attachments_table.delete_ok'
            ),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          console.log('removeAttachment CATCH: ', error)
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },

    // Descarga de pdf
    async downloadPdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })

      try {
        const params = {
          invoiceId: this.invoiceId
        }
        const filename = await this.downloadPendingTaskPdf(params)

        this.$notify({
          title: this.$t('pendingtask.pendingtask_detail.notify.download', {
            file: filename
          }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Descarga original firmado
    async downloadSignedOriginal () {
      console.log('downloadSignedOriginal: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const filename = await this.downloadInvoiceSignedOriginalPendingTask(
          this.invoiceId
        )
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadMetadata () {
      console.log('downloadMetadata: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })

      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        await this.downloadMetadata(params)
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Envío a Sap
    async sendToSapInvoice () {
      console.log('sendToSapInvoice: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('pendingtask.pendingtask_detail.sap.send')
      })
      try {
        this.$confirm(this.$t('new_invoice.invoice_totals.send_invoice.confirm.title_send_invoice'), {
          confirmButtonText: this.$t('new_invoice.invoice_totals.send_invoice.confirm.confirm_button_send_invoice'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          try {
            const params = {
              invoiceIds: this.invoiceId
            }

            await this.sendToSap(params)
            await this.getPendingTaskOnDatabase()

            this.$notify({
              title: this.$t('pendingtask.pendingtask_detail.sap.send_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          }
        }).catch(() => {})
      } finally {
        load.close()
      }
    },

    // Envia estado propuesta de pago
    async sendToPaymentProposalInvoice () {
      console.log('sendToPaymentProposalInvoice: ', this.invoiceId)

      const load = this.$loading({
        lock: true,
        text: this.$t('pendingtask.pendingtask_detail.paymentproposal.send')
      })

      try {
        const params = {
          invoiceIds: this.invoiceId
        }
        await this.sendPaymentProposal(params)
      } catch (error) {
        let errorArgList = []
        errorArgList = error.data.errorArgList
        console.log('--> errorArgList ', errorArgList)
        if (errorArgList && errorArgList[0].messageCode !== null) {
          for (let i = 0; i < errorArgList.length; i++) {
            let fullMessage = errorArgList[i].messageCode
            if (errorArgList[i].arguments === 'OK.') {
              fullMessage = this.$t('pendingtask.createcover.cover.send_multiple_ko') + errorArgList[i].messageCode

              await this.$notify({
                title: fullMessage,
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 15000
              })
            } else {
              await this.$notify({
                title: fullMessage,
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 15000
              })
            }
          }
        } else {
          this.getNotificationErrorMessage(error)
        }
      } finally {
        await this.refresh()
        load.close()
        this.isShowDialogPaymentProposal = false
      }
    },
    // Mostrar botón redigitalizar factura
    async showRedigitizeButton () {
      this.canRedigitize = false
      try {
        if ((this.invoiceOriginal.pendingTask === null || this.invoiceOriginal.pendingTask) && (this.invoiceOriginal.sent === null || !this.invoiceOriginal.sent)) {
          if (this.invoiceOriginal.receptionMethod !== null && (this.invoiceOriginal.receptionMethod === 'PAPER' || this.invoiceOriginal.receptionMethod === 'EMAIL') &&
              this.invoiceOriginal.status !== 'REJECTED_REDIGITALIZATION') {
            console.log('STATUS--> ', this.invoiceOriginal.status)
            this.canRedigitize = true
          }
        }
      } catch (error) {
        console.log('showRedigitizeButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.isShowDialogRegitize = false
      }
    },

    // Mostrar descarga de metadatos
    async showDownloadMetadata () {
      this.canDownloadMetadata = false
      try {
        if (this.invoiceOriginal.pathFileMetadata != null) {
          this.canDownloadMetadata = true
        }
      } catch (error) {
        console.log('showDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Rechazo de factura
    onSubmitRejectedInvoiceNote (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('onSubmitRejectedInvoiceNote!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.$t(
              'pendingtask.pendingtask_detail.rejectedinvoice.rejected'
            )
          })
          try {
            const request = {
              invoiceNoteId: this.invoiceId,
              categoryId: this.dialogRejectedInvoiceForm.categoryId,
              motive: this.dialogRejectedInvoiceForm.motive
            }

            await this.rejectedInvoice(request)
            if (this.projectWithApprovalFlowConfiguration) {
              router.push({
                name: 'tareaspendientes-page'
              })
            } else {
              await this.getPendingTaskOnDatabase()
              await this.showRedigitizeButton()
              // Comprobamos si se debe mostrar la descarga de metadatos
              await this.showDownloadMetadata()
            }

            this.$notify({
              title: this.$t(
                'pendingtask.pendingtask_detail.rejectedinvoice.rejected_ok'
              ),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('onSubmitRejectedInvoiceNote CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogRejectedInvoice = false
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    // Aprobación/envío de factura para el flujo de aprobación por niveles
    onSubmitApproveInvoiceNote (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('onSubmitApproveInvoiceNote!!!   ', this.fileList)
          const load = this.$loading({
            lock: true,
            text: this.loadingInApprovalDialog
          })
          try {
            const request = {
              invoiceNoteId: this.invoiceId,
              categoryId: this.dialogApproveInvoiceForm.categoryId,
              motive: this.dialogApproveInvoiceForm.motive
            }
            console.log('request: ', request)

            await this.sendApproveInvoice(request)
            await router.push({
              name: 'tareaspendientes-page'
            })
            this.$notify({
              title: this.approvalDialogSuccess,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    submitInvoiceDetailEditForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true
          })
          console.log('submitInvoiceDetailEditForm: ', this.pendingTaskDetailForm)
          try {
            // Guardamos Notas internas

            if (!this.pendingTaskDetailForm.internalNotes ||
              this.pendingTaskDetailForm.internalNotes == null) {
              this.pendingTaskDetailForm.internalNotes = ''
            }

            const request = {
              invoiceNoteId: this.invoiceId,
              internalNotes: this.pendingTaskDetailForm.internalNotes
            }
            await this.modifyInvoiceNoteInternalNotesPendingTask(request)

            // Cambio de estado
            const params = {
              invoiceId: this.invoiceId,
              statusId: this.pendingTaskDetailForm.statusId,
              observations: this.pendingTaskDetailForm.observations,
              categories: this.pendingTaskDetailForm.category
            }

            if (this.pendingTaskDetailForm.statusId && this.pendingTaskDetailForm.statusId !== null) {
              await this.modifyStatusHermesPendingTask(params)
            }

            this.$refs[formName].clearValidate()

            this.$notify({
              title: this.$t('invoice_detail.notification.submit_edit_invoice_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitResendInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
          } finally {
            await this.refresh()
            load.close()
          }
        } else {
          console.log('submitInvoiceDetailEditForm: ', this.pendingTaskDetailForm)
          return false
        }
      })
    },

    // Cancelar cambios
    async cancelInvoiceDetailEditForm () {
      // Detalle tarea pendiente
      await this.getPendingTaskOnDatabase()
    },

    async refresh () {
      // Detalle tarea pendiente
      await this.getPendingTaskOnDatabase()
      // Eventos
      await this.getEventsOnDatabase()
    },

    // Detalle tarea pendiente
    async getPendingTaskOnDatabase () {
      try {
        if (this.invoiceId) {
          const pendingTask = await this.getPendingTaskById(this.invoiceId)
          this.invoiceOriginal = JSON.parse(JSON.stringify(pendingTask))
          this.pendingTaskDetailForm = pendingTask
          if (this.invoiceOriginal.pendingTask == null) {
            this.pendingTaskDetailForm.pendingTask = true
          }
          if (this.pendingTaskDetailForm.levelApproval != null) {
            console.log('this.pendingTaskDetailForm.levelApproval: ', this.pendingTaskDetailForm.levelApproval)
            // Establecemos valores del formulario de aprobación por defecto:
            this.dialogApproveInvoiceForm.levelApproval = this.pendingTaskDetailForm.levelApproval
            if (!this.pendingTaskDetailForm.isLastLevelInApprovalFlow) {
              this.dialogApproveInvoiceForm.nextLevel = this.pendingTaskDetailForm.levelApproval + 1
            } else {
              this.dialogApproveInvoiceForm.nextLevel = null
            }
          }
        }
      } catch (error) {
        console.log('getPendingTaskOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.formatFields()
      }
    },

    // Eventos
    async getEventsOnDatabase () {
      try {
        if (this.invoiceId) {
          const params = {
            invoiceId: this.invoiceId
          }
          const response = await this.getEvents(params)
          this.events = response.data
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Adjuntos
    async getInvoiceNoteAttachmentsOnDatabase () {
      try {
        if (this.invoiceId) {
          const attach = await this.getInvoiceNoteAttachmentsPendingTask(
            this.invoiceId
          )
          this.attachments = attach
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async showSendPaymentProposal () {
      if (this.dialogPaymentProposalForm.categoryId === null && this.dialogPaymentProposalForm.description === null &&
        this.dialogPaymentProposalForm.namePaymentProposal === null && this.dialogPaymentProposalForm.status === null) {
        this.$notify({
          title: this.$t('pendingtask.createcover.noCoverPP') + this.dialogPaymentProposalForm.invoiceNumber + this.$t('pendingtask.createcover.noSendCoverPP'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      } else {
        // Propuesta de pago
        if (
          (this.pendingTaskDetailForm.pendingTask === null ||
        this.pendingTaskDetailForm.pendingTask) && this.invoiceId) {
          await this.getPaymentProposalOnDatabase()
        }
        this.isShowDialogPaymentProposal = true
      }
    },
    // Estado propuesta de pago
    async getPaymentProposalOnDatabase () {
      try {
        const response = await this.getPaymentProposal(
          this.invoiceId
        )
        this.dialogPaymentProposalForm = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Proyecto por nombre
    async getProjectByNameOnDatabase () {
      try {
        if (this.pendingTaskDetailForm.projectName) {
          const proj = await this.getProjectByName(
            this.pendingTaskDetailForm.projectName
          )
          if (proj.length > 1) {
            this.project = proj[0]
          } else {
            this.project = proj
          }
          if (this.project && this.project.id) {
            this.projectId = this.project.id
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Categorias
    async getCategoriesOnDatabase () {
      try {
        if (this.projectId) {
          const response = await this.getOptionsCategories(this.projectId)

          // Ordenamos alfabeticamente por codigo
          response.forEach(element => {
            element.code = this.$t('categories.' + element.code)
          })
          response.sort(function (a, b) {
            if (a.code < b.code) { return -1 }
            if (a.code > b.code) { return 1 }
            return 0
          })
          this.categories = response
          if (this.categories.length === 1) {
            this.dialogRejectedInvoiceForm.categoryId = this.categories[0].id
            this.dialogApproveInvoiceForm.categoryId = this.categories[0].id
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Estados hermes,para el cambio de estado de la tarea pendiente
    async getStatusHermesOnDatabase () {
      try {
        if (this.projectId) {
          this.statushermes = await this.getStatusHermesPendingTask(this.projectId)
          console.log(this.statushermes)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    formatFields () {
      // Obtenemos el label de la divisa a través de su código
      if (this.pendingTaskDetailForm.currencyCode) {
        this.pendingTaskDetailForm.currencyCode = this.$t('currency.' + this.pendingTaskDetailForm.currencyCode)
      }

      // Obtenemos el label del estado de la factura a través de su código
      if (this.pendingTaskDetailForm.status) {
        this.dialogRejectedInvoiceForm.status = this.$t('invoice_status.' + this.pendingTaskDetailForm.status)
        this.pendingTaskDetailForm.status = this.$t('invoice_status.' + this.pendingTaskDetailForm.status)
      }

      // Obtenemos el label del estado de la factura a través de su código
      if (this.pendingTaskDetailForm.internalStatus) {
        this.pendingTaskDetailForm.internalStatus = this.$t('invoice_status.' + this.pendingTaskDetailForm.internalStatus)
      }

      // Obtenemos el método de recepción y el método de envío a través de su código
      if (this.pendingTaskDetailForm.receptionMethod) {
        this.pendingTaskDetailForm.receptionMethod = this.$t('communication_method.' + this.pendingTaskDetailForm.receptionMethod)
      }

      // Formateamos los campos que sean números al locale
      this.pendingTaskDetailForm.totalExecutableAmount = this.$n(this.pendingTaskDetailForm.totalExecutableAmount, 'table')
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          if (this.urlIn && this.urlIn.includes('Correos')) {
            console.log('El usuario no tiene permisos para acceder al detalle de la tarea pendiente')
            this.$router.push({
              name: 'logincorreos'
            })
          } else if (this.urlIn && this.urlIn.includes('Vocento')) {
            console.log('El usuario no tiene permisos para acceder al detalle de la tarea pendiente')
            this.$router.push({
              name: 'loginvocento'
            })
          } else {
            this.$router.push({
              name: 'login'
            })
          }
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 500:
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 10000)
    },

    // Consulta de configuraciones del proyecto
    async getProjectConfigurations () {
      if (this.projectId) {
        const configuraciones = await this.getDataConfigurationCode({
          serviceId: this.projectId,
          dataconfigurationCode: 'APPROVAL_FLOW_BY_LEVELS_AND_USERS'
        })
        if (configuraciones && configuraciones.length > 0) {
          if (configuraciones[0]) {
            this.projectWithApprovalFlowConfiguration = true
          }
        }
        // Configuracion para poder añadir campos adicionales al primer nivel de aprobacion
        const campos = await this.getDataConfigurationCode({
          serviceId: this.projectId,
          dataconfigurationCode: 'REQUIRED_FIELDS_FOR_FIRST_LEVEL_APPROVAL'
        })
        if (campos && campos.length > 0) {
          if (campos[0]) {
            this.projectWithOptionalFieldsApprovalFlowConfiguration = true
          }
        }
      }
      console.log('projectWithApprovalFlowConfiguration: ', this.projectWithApprovalFlowConfiguration)
      console.log('projectWithOptionalFieldsApprovalFlowConfiguration: ', this.projectWithOptionalFieldsApprovalFlowConfiguration)
    },

    // Consulta de campos requeridos para la aporbacion a partir de la configuracion del proyecto
    async getProjectFields () {
      if (this.projectId) {
        const campos = await this.getDataConfigurationValueByCode({
          serviceId: this.projectId,
          dataconfigurationCode: 'REQUIRED_FIELDS_FOR_FIRST_LEVEL_APPROVAL'
        })
        if (campos && campos.length > 0) {
          this.fields = campos
        }
      }
      console.log('fields: ', this.fields)
    },

    async addApprovalField () {
      console.log('dialogApproveInvoiceForm', this.dialogApproveInvoiceForm)
      const load = this.$loading({
        lock: true,
        text: this.$t('pendingtask.pendingtask_detail.notify.save_field')
      })
      for (const field of this.fields) {
        if (this.dialogApproveInvoiceForm[field] !== null && this.dialogApproveInvoiceForm[field] !== undefined && this.dialogApproveInvoiceForm[field].trim() !== '') {
          // Guardamos el campo adicional
          await this.addInvoiceNoteApprovalParameterPendingTask({
            invoiceNoteId: this.invoiceId,
            code: field,
            value: this.dialogApproveInvoiceForm[field].trim(),
            numLine: this.numMaxLine
          })
        }
        // resetear campo
        if (this.dialogApproveInvoiceForm[field] != null) {
          this.dialogApproveInvoiceForm[field] = null
        }
      }

      // reset campos
      this.dialogApproveInvoiceForm.field = null
      this.dialogApproveInvoiceForm.value = null
      await this.getApprovalParameters()
      this.$notify({
        title: this.$t('pendingtask.pendingtask_detail.notify.save_field_ok'),
        type: 'success',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
      load.close()
    },

    async getApprovalParameters () {
      try {
        if (this.canUserApprovalFlowByLevels && this.projectWithOptionalFieldsApprovalFlowConfiguration && this.invoiceId) {
          const response = await this.getInvoiceNoteApprovalParametersPendingTask(this.invoiceId)
          this.approvalParameters = response.data
          console.log('approvalParameters: ', this.approvalParameters)

          // Inicializar numMaxLine
          this.numMaxLine = 0

          // Procesar campos para mostrar en la tabla
          const result = []
          const groupedByLine = {}

          // Agrupar los parámetros por numLine
          this.approvalParameters.forEach(param => {
            if (!groupedByLine[param.numLine]) {
              groupedByLine[param.numLine] = {}
            }
            groupedByLine[param.numLine][param.code] = param.value

            // Actualizar numMaxLine si el numLine actual es mayor
            this.numMaxLine = Math.max(this.numMaxLine, param.numLine)
          })

          // Construir el resultado final
          Object.keys(groupedByLine).forEach(numLine => {
            const newEntry = { numLine: parseInt(numLine, 10) } // Guardar el numLine en cada línea
            this.fields.forEach(field => {
              newEntry[field] = groupedByLine[numLine][field] || null // Si no existe el campo, inicializar como null
            })
            result.push(newEntry)
          })

          console.log(result)
          this.linesApprovalParameters = result
          this.numMaxLine = this.numMaxLine + 1 // Incrementar numMaxLine para el siguiente campo a añadir
          console.log('numMaxLine: ', this.numMaxLine) // Verificar el valor de numMaxLine
        }
        console.log('linesApprovalParameters: ', this.linesApprovalParameters)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async removeApprovalParameters () {
      console.log('removeApprovalParameters: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('pendingtask.pendingtask_detail.notify.delete_fields')
      })
      try {
        console.log('currentRow: ', this.currentRow)
        for (const code in this.currentRow) {
          if (code === 'numLine') {
            continue // Skip numLine
          }
          console.log('code: ', code)
          const value = this.currentRow[code]
          if (value !== null) {
            console.log(`Removing: code=${code}, value=${value}, numLine=${this.currentRow.numLine}`)
            await this.removeInvoiceNoteApprovalParameterPendingTask({
              invoiceNoteId: this.invoiceId,
              code: code,
              value: value,
              numLine: this.currentRow.numLine
            })
          }
        }
        await this.getApprovalParameters()
        this.$notify({
          title: this.$t('pendingtask.pendingtask_detail.notify.delete_fields_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        console.log('removeApprovalParameters: ', this.invoiceId)
        load.close()
      }
    },

    async loadEvents () {
    // Eventos
      if (this.canSeeEventsBpm && this.eventFlag) {
        this.eventFlag = false
        await this.getEventsOnDatabase()
        this.eventMessage = true
      }
    },

    async loadAttachments () {
    // Adjuntos
      if (this.canSeeAttachments && this.attachmentFlag) {
        this.attachmentFlag = false
        await this.getInvoiceNoteAttachmentsOnDatabase()
        this.attachmentMessage = true
      }
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const invoicId = []
      invoicId.push(this.$route.params.invoiceId)
      this.invoiceId = this.$route.params.invoiceId

      // Detalle tarea pendiente
      await this.getPendingTaskOnDatabase()

      // Proyecto por nombre
      await this.getProjectByNameOnDatabase()
      // configuraciones del servicio
      if (this.projectId) {
        const dat = {
          idProject: this.projectId
        }
        this.sendManual = await this.getSendManualConfig(dat)
        console.log('sendManual ', this.sendManual)
      }

      // Categorias
      await this.getCategoriesOnDatabase()
      // Statushermes
      await this.getStatusHermesOnDatabase()
      // Comprobamos se debe mostrar el boton de redigitalizar
      await this.showRedigitizeButton()
      // Comprobamos si se debe mostrar la descarga de metadatos
      await this.showDownloadMetadata()

      await this.invoiceNoteIdsPendingTaskState(invoicId)

      // Consultamos configuraciones del proyecto
      await this.getProjectConfigurations()

      // Obtenemos los campos adicionales para la tabla
      await this.getProjectFields()

      await this.getApprovalParameters()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-pendings-task {
  padding: 40px 40px 40px 40px;

  ::v-deep .customMargin{
    margin-top: 20px;
  }

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 40px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module {
      &__body{
        padding: 0px;
      }
    }
  }

  ::v-deep .ods-button.is-circle.is-circle {
    border: none;
    margin-top: 19px !important;
  }
}
</style>
